import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./BlogShow.css";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase"; // Ensure this path is correct

const BlogShow = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  
  // Function to fetch post data from Firebase
  async function getPost() {
    const docRef = doc(db, "AllBlogs", id); // Reference to specific blog post
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setData(docSnap.data());
    } else {
      console.log("No such document!");
    }
  }

  // Fetch post data when the component is mounted
  useEffect(() => {
    getPost();
  }, [id]); // Added dependency array to fetch new data when `id` changes

  return (
    <div>
      <div className="cont" style={{ background: "white" }}>
        <h1
          className="head h1_"
          style={{ color: "#F65AA8", textAlign: "center", paddingTop: "20px" }}
        >
          {data.title}
        </h1>
        <hr />
        <article className="post">
          <div
            style={{
              background: "white",
            }}
          ></div>
          <div className="post__container">
            <div className="post__content">
              <header>
                <span
                  className="post__category"
                  style={{ color: "#677077" }}
                >
                  {data.name}
                </span>{" "}
                <br />
                <time className="post__time" style={{ color: "#677077" }}>
                  {data.Date}
                </time>
              </header>
              <p
                className="post__text p_"
                style={{ color: "black", fontSize: "17px" }}
              >
                {data.text}
              </p>
            </div>
            <div className="post__link a_" style={{ width: "20%" }}>
              <Link to="/">Go To Home</Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogShow;
